module.exports = __webpack_public_path__ + "calculator.4c8a808e883e8799c01ce0ae1ef91718.svg";